import { render } from "./PlateLogs.vue?vue&type=template&id=16de8aae&scoped=true"
import script from "./PlateLogs.vue?vue&type=script&lang=js"
export * from "./PlateLogs.vue?vue&type=script&lang=js"

import "./PlateLogs.vue?vue&type=style&index=0&id=16de8aae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16de8aae"]])

export default __exports__